// Aanbiedingen - de 7 mooiste reizen van dit moment
// Alle prijzen zijn exclusief internationale vlucht.
export const populaireReizen = [
  {
    id: 'madeira',
    naam: '🇵🇹 Madeira',
    duur: '8 dagen',
    route: 'Funchal – Cabo Girão – Porto Moniz – Santana – Pico do Arieiro – Ponta de São Lourenço',
    prijs: 899,
    image_url: 'https://images.unsplash.com/photo-1528832135837-894ea33b2f50?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
  },
  {
    id: 'balkan-special',
    naam: '🇽🇰 🇲🇰 🇦🇱 Balkan Special',
    duur: '16 dagen',
    route: 'Pristina – Prizren – Skopje – Ohrid – Tirana – Berat – Gjirokastër – Albanese Rivièra',
    prijs: 999,
    image_url: 'https://images.unsplash.com/photo-1504972738139-adc5cfcf91c8?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb'
  },
  {
    id: 'georgie-deal',
    naam: '🇬🇪 Georgië',
    duur: '14 dagen',
    route: 'Tbilisi – Kazbegi – Gudauri – Kakheti – Kutaisi – Mestia – Batumi',
    prijs: 1199,
    image_url: 'https://images.unsplash.com/photo-1594766722982-fb4cd139ee7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnZW9yZ2lhJTIwa2F6YmVnaSUyMGNodXJjaCUyMG1vdW50YWlucyUyMGVwaWN8ZW58MHx8fHwxNzc2Mzc1NzkwfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'taiwan',
    naam: '🇹🇼 Taiwan',
    duur: '16 dagen',
    route: 'Taipei – Jiufen – Taroko Gorge – Sun Moon Lake – Alishan – Tainan – Kaohsiung',
    prijs: 1499,
    image_url: 'https://images.unsplash.com/photo-1470004914212-05527e49370b?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
  },
  {
    id: 'ecuador',
    naam: '🇪🇨 Ecuador',
    duur: '16 dagen',
    route: 'Quito – Otavalo – Cotopaxi – Baños – Cuenca – Guayaquil',
    prijs: 1699,
    image_url: 'https://images.unsplash.com/photo-1675870572266-45398339b326?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
  },
  {
    id: 'centraal-amerika',
    naam: '🇬🇹 🇭🇳 🇧🇿 🇲🇽 Guatemala, Honduras, Belize & Mexico',
    duur: '21 dagen',
    route: 'Guatemala City – Antigua – Lake Atitlán – Copán Ruinas – Caye Caulker – Bacalar – Tulum/Cancún',
    prijs: 1899,
    image_url: 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
  },
  {
    id: 'zambia-malawi',
    naam: '🇿🇲 🇲🇼 Zambia & Malawi',
    duur: '16 dagen',
    route: 'Lusaka – South Luangwa National Park – Lake Malawi – Nkhata Bay – Lilongwe',
    prijs: 2199,
    image_url: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0'
  }
];
